import { Brick, registerBrick, BrickContext } from 'olympe';
import { getLogger } from "@olympeio/core";

/**
 * Implements the method Number.toFixed, using the input number
 *
 * @extends Brick
 */
export default class NumberToFixed extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $                 Brick context
     * @param {number} input                    Input number to apply the `toFixed` method to
     * @param {number} n                        Number of decimals to rounf `input` with (default 0)
     * @param {function(string)} setResult      String representation of `input` at `n` decimals
     */
    update($, [input, n= 0], [setResult]) {
        // Get the logger for this coded function
        const logger = getLogger('NumberToFixed');

        // Ensure input is defined
        if(input === undefined) {
            logger.warn(`Input number cannot be undefined.`);
            setResult('');
        } else {
            // Call toFixed method on input number
            setResult(input.toFixed(n));
        }
    }
}

registerBrick('018f907aa999eae9c0ff', NumberToFixed);
